<template>
  <div class="px-3 mb-3 d-flex flex-row align-items-center gap-3">
    <button type="button" class="btn btn-outline-secondary btn-sm" @click="useNewVersion = !useNewVersion">
      Use {{ useNewVersion ? 'old' : 'new' }} editor
    </button>
    <template v-if="useNewVersion">
      <button type="button" class="btn btn-outline-secondary btn-sm" @click="showPreview = !showPreview">
        Show {{ showPreview ? 'editor' : 'preview' }}
      </button>
      <div v-if="parseError" class="text-danger">
        {{ parseError.message }}
      </div>
      <button v-else type="button" class="btn btn-outline-primary btn-sm ms-auto" @click="commit">
        Update
      </button>
    </template>
  </div>
  <div v-if="useNewVersion" class="mx-3 mb-3">
    <b-textarea v-if="!showPreview" v-model="surveyJsonString" min-rows="20" class="font-monospace" />
    <SurveyComponent v-else :model="model" />
  </div>
  <div v-else>
    <div class="list-group list-group-flush border-top border-bottom">
      <div v-for="field in form.fields" :key="field.id" class="list-group-item p-4">
        <LicenseApplicationFormEditorRow :field="field" :form="form" />
      </div>
    </div>
    <div class="d-flex flex-row px-4 py-2">
      <button class="btn btn-primary" type="button" @click="addCustomField">
        Add Field
      </button>
    </div>
  </div>
</template>

<script>
import {LicenseApplicationForm} from "@/models/LicenseApplicationForm";
import LicenseApplicationFormEditorRow from "@/components/admin-city/licenses/LicenseApplicationFormEditorRow.vue";
import {SurveyComponent} from "survey-vue3-ui";
import BTextarea from "@/components/common/BTextarea.vue";
import SurveyModel from "@/models/SurveyModel";

export default {
  components: {BTextarea, SurveyComponent, LicenseApplicationFormEditorRow},
  props: {
    form: LicenseApplicationForm
  },
  data() {
    return {
      model: null,
      showPreview: false,
      surveyJsonString: '',
      parseError: null
    };
  },
  mounted() {
    this.model = SurveyModel.createFromApplicationForm(this.form, {editable:true});
    this.surveyJsonString = JSON.stringify(this.surveyJson, null, 2);
  },
  watch: {
    surveyJsonString: {
      immediate: true,
      handler()  {
        try {
          const surveyJson = JSON.parse(this.surveyJsonString);
          this.model = SurveyModel.createFromJson(surveyJson, {editable:true});
          this.parseError = null;
        } catch (e) {
          this.parseError = e;
        }
      }
    }
  },
  computed: {
    surveyJson() {
      return this.form.surveyJson;
    },
    useNewVersion: {
      get() {
        return this.form.useNewVersion;
      },
      set(v) {
        this.form.useNewVersion = v;
        this.form.commit();
      }
    }
  },
  methods: {
    addCustomField() {
      this.form.addField();
    },
    async commit() {
      const surveyJson = JSON.parse(this.surveyJsonString);
      this.form.surveyJson = surveyJson;
      await this.form.commit();
    }
  }
}
</script>
